var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.903 12.132c-1.465 1.17-2.367 1.75-3.28 1.75-.872 0-1.754-.543-3.117-1.605l-8.117 7.14h22.85l-8.245-7.355-.093.07h.002zm-9.622-2.35a683.345 683.345 0 0 1-6.278-4.89v13.46c.006.04.014.08.025.12l8.179-7.199c-.593-.469-1.229-.953-1.923-1.49l-.003-.001zm19.546 8.881c.038-.1.06-.205.063-.312V4.32c-2.87 2.23-5.735 4.467-8.592 6.713l8.53 7.631zM24.272 0H1.618A2.248 2.248 0 0 0 0 1.618v1.275c2.387 1.9 4.978 3.899 7.174 5.593 1.21.935 2.296 1.775 3.157 2.443 2.309 1.81 2.309 1.81 4.665-.073 2.13-1.704 7.865-6.165 10.899-8.524V1.62A2.245 2.245 0 0 0 24.272 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4bd10e4757a9f7aecb084d4564edd5c8.svg";
export { ForwardRef as ReactComponent };